import { useState } from "react";
import styles from "../styles/RealizationView.module.css";

import Sales from "./Realization/Sales";
import Invoices from "./Realization/Invoices";
import Returns from "./Realization/Returns";
import Shortages from "./Realization/Shortages";
import CanceledProducts from "./Realization/CanceledProducts";

const RealizationView = () => {
  const [activeTab, setActiveTab] = useState("sales");

  const tabs = [
    { id: "sales", label: "Продажи" },
    { id: "invoices", label: "Счет на оплату" },
    { id: "returns", label: "Возвраты" },
    { id: "shortages", label: "Недостачи" },
    { id: "canceled", label: "Отмененные товары" },
  ];

  const renderContent = () => {
    switch (activeTab) {
      case "sales":
        return <Sales />;
      case "invoices":
        return <Invoices />;
      case "returns":
        return <Returns />;
      case "shortages":
        return <Shortages />;
      case "canceled":
        return <CanceledProducts />;
      default:
        return null;
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`${styles.tabButton} ${
              activeTab === tab.id ? styles.active : ""
            }`}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className={styles.content}>{renderContent()}</div>
    </div>
  );
};

export default RealizationView;
